/* MultiEditHandler.js */

"use strict";
const _ = require("lodash");

class MultiEditHandler {
    constructor(fcd, powerButton) {
        this.powerButton = powerButton;
        this.fcd = fcd;
        this._registerListeners();
    }

    _registerListeners() {
        this.powerButton.on(
            "Value",
            (this._onPowerButtonChange = this._onPowerButtonChange.bind(this))
        );
    }

    /**
     * Register listener on the adapter after it's been created and initialized
     * This should be called after the adapter's InitializationComplete event
     */
    registerAdapterListener() {
        let adapter = this.fcd.adapterInfo.adapter;
        if (adapter && !this._adapterListenerRegistered) {
            adapter.on(
                "ValueRestored",
                (this._onAdapterValueRestored = this._onAdapterValueRestored.bind(this))
            );
            this._adapterListenerRegistered = true;
        }
    }

    _unregisterListeners() {
        this.powerButton.removeListener("Value", this._onPowerButtonChange);

        let adapter = this.fcd.adapterInfo.adapter;
        if (adapter && this._onAdapterValueRestored) {
            adapter.removeListener("ValueRestored", this._onAdapterValueRestored);
        }
    }

    tearDown() {
        this._unregisterListeners();
    }

    _onPowerButtonChange() {
        let adaptr = this.fcd.adapterInfo.adapter;
        if (_.isFunction(adaptr.setMultiEditActive)) {
            adaptr.setMultiEditActive(this.powerButton.getValue());
        } else {
            console.warn(
                "Adapter " +
                    this.fcd.adapterInfo.class.name +
                    " missing setMultiEditActive function"
            );
        }
    }

    _onAdapterValueRestored() {
        this.powerButton.setOn();
        let adapter = this.fcd.adapterInfo.adapter;
        if (adapter && _.isFunction(adapter.setMultiEditActive)) {
            adapter.setMultiEditActive(true);
        }
    }
}

module.exports = MultiEditHandler;
